import { callback } from './../util/useAuthShop'
import { RouteRecordRaw } from 'vue-router'
import { createStore, ModuleTree } from 'vuex'
import use from './utils'
import { Site, CountriesEnum, apiShopName, jpWareInfo, ShopType } from '@/common/const'
import '@/views/brand/components/suffix'
import { TripartiteUserInfo } from './modules/tripartite'
import { COUNTRY } from '@/global'
import { LineCheckRespDTO, ShopPurchaseRespDTO } from '@/service/customer'

import { getGrayOverseasInvApi } from '@/apis/user'
export interface R {
  route: {
    promise: Promise<any>;
    routes: RouteRecordRaw[];
    token: string | null;
    plat: string;
    user: Record<string, unknown>;
    userShops: any[];
    curShop: any;
    notProcessedOrder: any;
    site: string;
    shippingListNum: any,
    loginName: string,
    memberRate: number,
    onlyOpenSpecail: boolean,
    /** 一价全包白名单用户 */
    isAllCalUser: boolean;
    ip: number,
    href: string,
    isChoiceShop: boolean
    openMoreWare: boolean
    moreWareConfig: ShopPurchaseRespDTO;
    lineActivity: LineCheckRespDTO;
    supportCombineAutoAddTk?: boolean;
  };
  bussiness: {
    Shops: any[];
    viaCrx: boolean;
    model: any;
    schannel: any;
  };
  observe: {
    scroll: number;
  };
  status: {
    editing: boolean;
    renderSidebar: boolean;
    shopReplenishInfo: any;
    isJpPurchase: boolean
  };
  extension: {
    isInstall: boolean;
  };
  tripartite: TripartiteUserInfo
  whiteUser: {
    isCrossMall: boolean
    isAllincludePriceJp: boolean
    isPreSaleWhiteList: boolean
  }
}

// modules
const files = require.context('./modules', false, /\/[a-z].*\.[jt]s$/)
const modules = files.keys().reduce((all: ModuleTree<R>, fileName: string) => {
  const { default: module } = files(fileName)
  if (module) {
    const key = (fileName.match(/([^./]+).[jt]s/) || '')[1]
    all[key] = module
  }
  return all
}, {})

const root = {
  getters: {
    token: (state: R): string | null => {
      return state.route.token
    },
    user: (state: R): any => {
      // debugger
      return state.route.user
    },
    userShops: (state: R): any => {
      return state.route?.user?.customerShopList || []
    },
    curShop: (state: R): number => {
      return state.route.curShop
    },
    shopInfo: (state: R): any => {
      const t: any = state.route?.user?.customerShopList || []
      return (
        t.find((v: any) => v.customerShopId === state.route.curShop) ??
        {}
      )
    },
    // 全局多仓配置
    moreWareConfig: (state: R): any => {
      return state.route?.moreWareConfig || {}
    },
    shopname: (state: R): any => {
      const t: any = state.route?.user?.customerShopList || []
      return (
        t.find((v: any) => v.customerShopId === state.route.curShop)
          ?.customerShopName ?? ''
      )
    },
    isSub: (state: R): boolean => {
      return state.route.user?.accountType === 2
    },
    plat: (state: R): string => {
      return state.route.plat
    },
    scroll: (state: R): number => {
      return state.observe.scroll
    },
    editing: (state: R): boolean => {
      return state.status.editing
    },
    isLogin(state: R): boolean {
      return !!state.route.token
    },
    viaCrx(state: R): boolean {
      return state.bussiness.viaCrx
    },
    membership(state: R) {
      return state.route.user?.membership || {}
    },
    isInstall(state: R) {
      return state.extension.isInstall
    },
    notProcessedOrder(state: R) {
      return state.route.notProcessedOrder
    },
    shippingListNum(state: R) {
      return state.route.shippingListNum
    },
    renderSidebar(state: R) {
      return state.status.renderSidebar
    },
    site(state: R) {
      return state.route.site
    },
    memberRate(state: R) {
      return state.route.memberRate
    },
    ip(state: R) {
      return state.route.ip
    },
    href(state: R) {
      return state.route.href
    },
    onlyOpenSpecail(state: R) {
      return state.route.onlyOpenSpecail
    },
    isMultiStore(state: R) {
      // 如果不是日本站点直接返回false
      if (!isJA()) {
        return false
      }
      return state.route.user?.hasKoreaWallet
    },
    isChoiceShop: (state: R): boolean => {
      return state.route.isChoiceShop
    },
    isCrossMall(state: R) {
      return state.whiteUser.isCrossMall
    },
    shopReplenishInfo(state: R) {
      return state.status.shopReplenishInfo
    },
    isJpPurchase(state: R) {
      return state.status.isJpPurchase
    },
    lineActivity(state: R) {
      return state.route.lineActivity
    },
    isAllincludePriceJp(state: R) {
      return state.whiteUser.isAllincludePriceJp
    },
    isPreSaleWhiteList(state: R) {
      return state.whiteUser.isPreSaleWhiteList
    }
  },
  mutations: {},
  actions: {},
  modules: modules,
  plugins: []
}

use(root).bindMutation().persistState()

const store = createStore(root)
export default store

export const isMultiStore = (): boolean => store.getters.isMultiStore && !isWhiteHiddenRMB()

export const useToken = (): string => store.getters.token
export const useCurShop = (): string => store.getters.curShop
export const isSub = (): string => store.getters.isSub
export const useUser = (): any => store.getters.user
export const usePlat = (): string => store.getters.plat
export const useSite = () => store.getters.site as 'ko' | 'ja' | 'en' // ja ko en
export const useLevel = () => useUser()?.membership?.templateLevel ?? 0
export const isMember = () => useUser()?.membership?.templateLevel > 0
export const isChoiceShop = (): string => store.getters.isChoiceShop || store.getters.shopInfo?.supportChoice === 1
export const isJpPurchase = () => store.getters.isJpPurchase && !isTikTokShop()
export const isJpPurchaseHasTikTok = () => store.getters.isJpPurchase && isTikTokShop()
// 白名单客户-》针对固定客户，开启固定一口价的商品，订单隐藏人民币金额
// export const isWhiteHiddenRMB = () => store.getters.isAllincludePriceJp
// 美国站指定店铺售卖一口价订单
export const isWhiteHiddenRMB = () => store.getters.shopInfo?.supportLiveDevice
export const use_OEM_CountryCode = (): string => {
  const site = useSite() as 'ko' | 'ja' | 'en'
  return {
    ja: 'JP',
    ko: 'KR',
    en: 'GB'
  }[site]
} // ja ko en

export const useSite2Station = (): Site => {
  const site = useSite() as 'ko' | 'ja' | 'en'
  return {
    ja: Site.JA,
    ko: Site.KO,
    en: Site.EN
  }[site]
}
export const isShowBySite = (v: any) => {
  const { includes = ['ja', 'ko', 'en'], excludes = [] } = v
  const site = useSite()
  if (excludes.includes(site)) return false
  if (includes.includes(site)) return true
  return false
}

// 站点转JP KR GB
export const useSite2Code = () => {
  const site = useSite() as 'ko' | 'ja' | 'en'
  return {
    ja: CountriesEnum.Japan,
    ko: CountriesEnum.Korea,
    en: CountriesEnum.UK
  }[site]
}

export const isJA = () => {
  return useSite() === 'ja'
}

export const isKO = () => {
  return useSite() === 'ko'
}

export const isJK = () => {
  return ['ko', 'ja'].includes(useSite())
}
export const isJE = () => {
  return ['en', 'ja'].includes(useSite())
}

export const isEN = () => {
  return useSite() === 'en'
}
// 获取当前用户的国家二字码
export const getCustomerNationCode = () => {
  if (isJK()) {
    return useSite2Code()
  }
  return store.getters?.user?.nationCode || 'OTHER'
}
export const getCustomerNationCode2 = () => {
  if (isJK()) {
    return useSite2Code()
  }
  return store.getters?.user?.nationCode || 'GB'
}
export const siteffix = () => isJA() ? 'Jp' : isKO() ? 'Kr' : isEN() ? 'En' : 'Cn'

export const isD2C = (): boolean => store.getters.plat === 'd2c'
// 国际料金pdf
export const expressCostPdf = (): string => isJA() ? '/hub/calculate' : '/oem/utility/inteMaterialCosts'

export const useSource = (data = {}): { systemSource: number } => {
  return { systemSource: store.getters.plat === 'b2b' ? 2 : 1, ...data }
}
export const useCustomerShopId = (): { customerShopId: string } => {
  return { customerShopId: store.getters.curShop }
}

export const useRtfix = (name: string, obj = {}): any => {
  return {
    ...obj,
    name:
      name + (useSite() ? '_' + useSite() : '')
  }
}

export const useRtAffix = () => `/${useSite()}/${usePlat()}/`

export const getCustomerShopPlatform = () => {
  return apiShopName[store.getters?.shopInfo?.customerShopPlatform] ?? '-'
}
/** d2c直发最大金额韩国站最大金额1000 */
const D2CMaxMoney = ''

export const getWarehouseCode = (isMultiGoods?: boolean) => {
  const warehouseList = store.getters?.shopInfo?.warehouseList ?? []
  if (isMultiGoods) {
    return warehouseList.find((v: { warehouseCountry: string }) => v.warehouseCountry === 'KR')?.warehouseCode
  }
  return warehouseList.find((v: { warehouseCountry: string }) => v.warehouseCountry === 'CN')?.warehouseCode
}

/** 通过国家获取 */
export const getWarehouseByCountry = (country: COUNTRY = COUNTRY.CN) => {
  const warehouseList = store.getters?.shopInfo?.warehouseList ?? []
  if (country === COUNTRY.JP) {
    return jpWareInfo.warehouseCode
  }
  return warehouseList.find((v: { warehouseCountry: string }) => v.warehouseCountry === country)?.warehouseCode
}

export const getWarehouseCodes = () => {
  const warehouseList = [...(store.getters?.shopInfo?.warehouseList ?? []), jpWareInfo]
  return warehouseList.map((v: any) => v.warehouseCode)
}
// 获取仓库对应国家code
export const getWarehouseCodeCountry = (warehouseCode: string) => {
  const warehouseList = [...(store.getters?.shopInfo?.warehouseList ?? []), jpWareInfo]
  return warehouseList.find((v: any) => v.warehouseCode === warehouseCode)?.warehouseCountry
}

export const isTikTokShop = () => store.getters.shopInfo?.customerShopPlatform === ShopType.TIKTOK
export const isShopifyShop = () => store.getters.shopInfo?.customerShopPlatform === ShopType.SHOPIFY

export const isShowStockJpBtn = async () => {
  if (!isD2C()) return false
  const { data } = await getGrayOverseasInvApi()

  // overseasInvCheck 按钮是否展示true
  // overseasInvOnlyTiktokCheck true只tk展示,false全部展示
  // shopOverseasInvCheck 白名单权限， true直接展示
  const { overseasInvCheck, overseasInvOnlyTiktokCheck, shopOverseasInvCheck } = data ?? {}
  if (shopOverseasInvCheck) return true
  if (!overseasInvCheck) return false
  if (overseasInvOnlyTiktokCheck) {
    return isTikTokShop()
  }
  return false
}
export const is3RDCustomerShop = () => isShopifyShop() && ['7', '87', '36236'].includes(store.getters.user?.superCustomerId)
